@if (isWide() && (menuConfiguration()?.logo || selectedMenuArea()?.logo)) {
  @if (selectedMenuArea()?.logo?.iconRelativePath) {
    <img class="logo" [src]="selectedMenuArea()?.logo?.iconRelativePath | webResourceUri | async" />
  } @else {
    @if (menuConfiguration()?.logo?.iconRelativePath) {
      <img class="logo" [src]="menuConfiguration()?.logo?.iconRelativePath | webResourceUri | async" />
    }
  }
}

@if (!isWide() && (menuConfiguration()?.miniLogo || selectedMenuArea()?.miniLogo)) {
  @if (selectedMenuArea()?.miniLogo?.iconRelativePath) {
    <img class="mini-logo" [src]="selectedMenuArea()?.miniLogo?.iconRelativePath | webResourceUri | async" />
  } @else {
    @if (menuConfiguration()?.miniLogo?.iconRelativePath) {
      <img class="mini-logo" [src]="menuConfiguration()?.miniLogo?.iconRelativePath | webResourceUri | async" />
    }
  }
}
